module.exports = __webpack_public_path__ + "media/icons/close-3110815a.svg";